import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const tok = localStorage.getItem("gc_token");
  if (tok) config.headers.Authorization = `Bearer ${tok}`;
  return config;
});

api.interceptors.response.use(
  (r) => {
    // Sliding-session renewal: backend returns a fresh token in
    // `X-Refresh-Token` whenever the current one is older than the
    // configured threshold (default 5 min). Persist it as the new access
    // token so every subsequent request restarts the inactivity timer.
    const newToken = r?.headers?.["x-refresh-token"] || r?.headers?.["X-Refresh-Token"];
    if (newToken && typeof newToken === "string" && newToken.length > 10) {
      try {
        localStorage.setItem("gc_token", newToken);
      } catch (_) {
        /* storage disabled → ignore */
      }
    }
    return r;
  },
  (error) => {
    if (error?.response?.status === 401) {
      const path = window.location.pathname;
      const onLogin = path.endsWith("/login") || path === "/";
      if (!onLogin) {
        localStorage.removeItem("gc_token");
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Erro inesperado";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (typeof e?.msg === "string" ? e.msg : (typeof e?.message === "string" ? e.message : JSON.stringify(e)))).join(" — ");
  if (typeof d?.message === "string") return d.message;
  if (typeof d?.msg === "string") return d.msg;
  if (typeof d?.detail === "string") return d.detail;
  return err?.message || "Erro inesperado";
}
